import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { BulletinType } from 'src/app/masters/bulletin-type/bulletin-type';
import { Vehicle } from 'src/app/masters/vehicle/vehicle';
import { RepairGroup } from 'src/app/masters/repair-group/repair-group';
import { BulletinTypeService } from 'src/app/masters/bulletin-type/bulletin-type.service';
import { VehicleService } from 'src/app/masters/vehicle/vehicle.service';
import { RepairGroupService } from 'src/app/masters/repair-group/repair-group.service';
import { BulletinService } from '../bulletin.service';
import { Bulletin } from '../bulletin';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { BulletinFile } from '../bulletin-file';
import { ParamService } from 'src/app/masters/param/param.service';
import { Param } from 'src/app/masters/param/param';
import { UserService } from 'src/app/core/auth/user.service';
import { StatusService } from 'src/app/masters/status/status.service';
import { Status } from 'src/app/masters/status/status';
import { BulletinFilter } from '../bulletin-filter';
import { BulletinReport } from '../bulletin-report';
import { Role } from 'src/app/masters/role/role';
import { RoleService } from 'src/app/masters/role/role.service';


@Component({
    templateUrl: './bulletin-form.component.html',
    styleUrls: ['./bulletin-form.component.css']

})
export class BulletinFormComponent implements OnInit {

    bulletinTypes: BulletinType[] = [];
    vehiclesFull: Vehicle[] = [];
    vehicles: Vehicle[] = [];
    repairGroups: RepairGroup[] = [];
    status: Status[];
    bulletinsFull: Bulletin[] = [];
    bulletins: Bulletin[] = [];
    
    roles: Role[] =[];
    selectedRoles: Role[] =[];

    msgs: Message[] = [];
    
    files: BulletinFile[] = [];
    selectedFile: BulletinFile;

    id: number;
    edit: boolean;
    bulletinForm: FormGroup

    param: Param = new Param();

    filter: BulletinFilter;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private bulletinTypeService: BulletinTypeService,
        private vehicleService: VehicleService,
        private repairGroupService: RepairGroupService,
        private bulletinService: BulletinService,
        private paramService: ParamService,
        private userService: UserService,
        private statusService: StatusService,
        private roleService: RoleService,
    ) { }

    ngOnInit() {
        this.edit = false;
        this.filter = history.state.filter;
        this.id = this.route.snapshot.params.id;
        this.bulletinForm = new FormGroup({
            code: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(9)]),
            description: new FormControl('', Validators.required),
            bulletinType: new FormControl('', Validators.required),
            vehicle: new FormControl('', Validators.required),
            repairGroup: new FormControl('', Validators.required),
            status: new FormControl('', Validators.required),
            contractStart: new FormControl('', Validators.required),
            replacedBy: new FormControl(),
            files: new FormControl(),
            replace: new FormControl(),

            insertDate: new FormControl(),
            insertUser: new FormControl(),
            updateDate: new FormControl(),
            updateUser: new FormControl(),
        });
        this.initCombo();
        
        this.paramService.findActive().subscribe(param => {
            this.param = param;
        });

        this.roleService.findAll().subscribe(items => {
            this.roles = items.filter(x => x.status.id == 1);

            if (this.id) {
                this.edit = true;
                this.fillForm();
            }
        });
    }

    fillForm(){
        this.bulletinService.find(this.id).subscribe(item => {
            this.bulletinForm.get('code').setValue(item.code);
            this.bulletinForm.get('code').disable();
            this.bulletinForm.get('description').setValue(item.description);
            this.bulletinForm.get('bulletinType').setValue(item.bulletinType);
            this.bulletinForm.get('bulletinType').disable();

            this.selectVehicleRepairGroup(item);
            this.bulletinForm.get('status').setValue(item.status);

            if(item.replacedBy != null){
                item.replacedBy.files = null;
                item.replacedBy.roles = null;
                this.bulletinForm.get('replacedBy').setValue(item.replacedBy);
            }

            this.bulletinForm.get('replace').setValue(false);

            if (item.contractStart  != null) this.bulletinForm.get('contractStart').setValue(new Date(item.contractStart));

            this.bulletinForm.get('insertUser').setValue(item.insertUser);
            this.bulletinForm.get('updateUser').setValue(item.updateUser);
            
            if (item.insertDate  != null) this.bulletinForm.get('insertDate').setValue(new Date(item.insertDate));
            if (item.updateDate  != null) this.bulletinForm.get('updateDate').setValue(new Date(item.updateDate));
            
            this.selectedRoles = this.roles.filter(role => JSON.stringify(item.roles).includes(JSON.stringify(role)));
            this.bulletinForm.get('files').setValue(item.files);
            this.files = [];
            for (let iitem of item.files){
                this.selectedFile = this.cloneFile(iitem);
                this.files = this.files.concat([this.selectedFile]);
            }
        });
    }

    changeType(){
        this.codePrefix();
        this.selectVehicleRepairGroup(null);
    }

    codePrefix(){
        this.bulletinForm.get('code').setValue(this.bulletinForm.get('bulletinType').value.code + "-");
    }

    selectVehicleRepairGroup(item: Bulletin){
        if(this.bulletinForm.get('bulletinType').value.code != "BS"){
            
            this.bulletinForm.get('vehicle').setValue(this.vehicles[0]);
            this.bulletinForm.get('repairGroup').setValue(this.repairGroups[0]);
            this.bulletinForm.get('vehicle').disable();
            this.bulletinForm.get('repairGroup').disable();
        }else{
            if(item){
                this.bulletinForm.get('vehicle').setValue(item.vehicle);
                this.bulletinForm.get('repairGroup').setValue(item.repairGroup);
            }else{
                this.bulletinForm.get('vehicle').setValue(null);
                this.bulletinForm.get('repairGroup').setValue(null);
            }

            this.bulletinForm.get('vehicle').enable();
            this.bulletinForm.get('repairGroup').enable();
        }
    }

    initCombo() {
        
        this.statusService.findAll().subscribe(items => {
            this.status = items.filter(x => x.type == "Boletim");
        });

        this.bulletinTypeService.findAll().subscribe(items => {
            this.bulletinTypes = items.filter(x => x.status.id == 1);
        });

        this.vehicleService.findAll().subscribe(items => {
            this.vehiclesFull = [{id: null, vehicleBrand: null, description: "- Não informado -", status:null}].concat(items.filter(x => x.status.id == 1));
            this.vehicles = this.vehiclesFull;
        });

        this.repairGroupService.findAll().subscribe(items => {
            this.repairGroups = [{id: null, description: "- Não informado -", status:null}].concat(items.filter(x => x.status.id == 1));
        });
    }

    checkValid(event: any){
        if(event.target.value) {
            let code = event.target.value;
            this.bulletinService.findByCode(code).subscribe(item => {
                if(item){
                    this.msgs.push({severity:'error', detail:'Código já foi cadastrado anteriormente!'});
                    return;
                }
            });
        }
     }

    checkExits(code: string) {
        let filter = {} as BulletinFilter;
        filter.code = code;
        this.bulletinService.findByCode(code).subscribe(item => {
            if(item){
                this.msgs.push({severity:'error', detail:'Código já foi cadastrado anteriormente!'});
                return;
            }
        });
        
       

        return null;

    }

    search(event) {
        this.bulletinService.findExcept(this.id, event.query).subscribe(items => {
            this.bulletins = items;
        });
    }

    save() {
        this.msgs = [];

        const code = this.bulletinForm.get('code').value.split("-");
        let bulType = this.bulletinForm.get('bulletinType').value;

        const codeBulletin = this.bulletinForm.get('code').value;
        this.bulletinService.findByCode(codeBulletin).subscribe(item => {
            if(item && item.id != this.id){
                this.msgs.push({severity:'error', detail:'Código já foi cadastrado anteriormente!'});
                return;
            }

            if(bulType.code != code[0]){
                this.msgs.push({severity:'error', detail:'Prefixo do código deve ser relacionado ao tipo de boletim!'});
                return;
            }
            if(code[0].length > 3 || code[1].length > 5){
                this.msgs.push({severity:'error', detail:'Código inválido!'});
                return;
            }
    
            if (this.bulletinForm.valid && !this.bulletinForm.pending) {
                let bulletin = this.bulletinForm.getRawValue() as Bulletin;
    
                if (bulletin.repairGroup != null && bulletin.repairGroup.id == null)
                    bulletin.repairGroup = null;
                if (bulletin.vehicle != null && bulletin.vehicle.id == null)
                    bulletin.vehicle = null;
    
                bulletin.roles = this.selectedRoles;
                
                let user = this.userService.getUserName();
                if(this.id){        
                    bulletin.id = this.id;
                    this.bulletinService.update(bulletin, user).subscribe( params => {
                        
                        this.fillForm();
                        this.msgs.push({
                            severity: 'success',
                            detail: 'Registro modificado'
                        });
                    });
                }else{
                    this.bulletinService.save(bulletin, user).subscribe( params => {
                        bulletin.id = params.id;
                        this.id = params.id;
    
                        this.bulletinForm.get('insertUser').setValue(params.insertUser);
                        this.bulletinForm.get('insertDate').setValue(new Date(params.insertDate));
                        this.bulletinForm.get('code').disable();
                        this.bulletinForm.get('bulletinType').disable();
            
                        this.msgs.push({
                            severity: 'success',
                            detail: 'Registro incluído'
                        });
                    }, err => {
                        this.msgs.push({severity:'error', detail:'Erro ao Salvar Registro!'});
                        return;
                    });
                }
            }
        });
    }

    back(){
        this.router.navigate(['bulletins'], {state: {filter: this.filter}});
    }

    new(){
        this.bulletinForm.reset();
        this.selectedRoles = [];
        this.files = [];
        this.edit = false;
        this.id = null;
        this.bulletinForm.get('code').enable();
        this.bulletinForm.get('bulletinType').enable();
    }

    newFile(event, form) {
        if (this.id == null || event.files == null || event.files[0] == null) return;
        this.msgs = [];

        let replace = this.bulletinForm.get('replace').value;
        if(replace == null) replace = false;

        event.files.forEach(file => {
            this.bulletinService.upload(this.id, replace, file).subscribe( params => {
                this.selectedFile = { bulletin: params.bulletin, fileName:params.fileName, id:params.id, insertDate:params.insertDate, insertUser:params.insertUser }
                if(replace){
                    let index = this.files.findIndex(x=>x.fileName === this.selectedFile.fileName)
                    if(index > -1){
                        this.files.splice(index, 1);
                    }
                    
                    this.files = this.files.concat([this.selectedFile]);
                    this.msgs.push({
                        severity: 'success',
                        detail: 'Arquivo substituído'
                    });

                    this.bulletinForm.get('replace').setValue(false);
                } else {
                    this.files = this.files.concat([this.selectedFile]);
                    this.msgs.push({
                        severity: 'success',
                        detail: 'Arquivo incluído'
                    });
                }

                form.clear();
            }, err => {
                this.msgs.push({
                    severity: 'error',
                    detail: 'Não é possível incluir o arquivo'
                });
            });
        })
    }

    deleteFile(file : BulletinFile){
        this.msgs = [];
        file.bulletin = this.bulletinForm.getRawValue() as Bulletin;
        file.bulletin.id = this.id;

        this.bulletinService.deleteFile(file).subscribe( params => {
            this.fillForm();

            this.msgs.push({
                severity: 'success',
                detail: 'Arquivo excluído'
            });
        }, err => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o arquivo'
            });
        });
    }

    downloadFile(file : BulletinFile){
        this.msgs = [];
        file.bulletin = this.bulletinForm.getRawValue() as Bulletin;
        file.bulletin.id = this.id;

        
            let report = new BulletinReport();
            report.bulletinCode = file.bulletin.code;
            report.bulletinDescription = file.bulletin.description;
            report.dealerNumber = this.userService.getDealerNumber();
            report.vehicle = file.bulletin.vehicle?.description;
            report.lastUpdate = (file.bulletin.updateDate == null) ? file.bulletin.insertDate : file.bulletin.updateDate;
            report.usrLastUpdate = (file.bulletin.updateUser == null) ? file.bulletin.insertUser : file.bulletin.updateUser;

            let user = this.userService.getUserName();
            this.bulletinService.download(file, report, user).subscribe(
                (ret: Blob) => {
                    saveAs(ret, file.fileName);
                }
            );
        
    }

    cloneFile(i: BulletinFile): BulletinFile{
        let iitem = { bulletin: null, fileName:null, id:null, insertDate:null, insertUser:null }
        for(let prop in i){
            iitem[prop] = i[prop];
        }
        return iitem;
    }
}